import React from 'react'
import { To, useNavigate } from "react-router-dom";
import './NavButton.css'

export interface Props {
    text: String
    route: String
}

export function NavButton({text, route}: Props) {
    const navigate = useNavigate()

    const handleNavigate = () => {
        navigate(route as To)
    }

    return <div className='NavButton' onClick={handleNavigate}>{text}</div>
}